import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Subscription } from 'rxjs';

@Component({
  selector: 'app-cursos-lista',
  templateUrl: './cursos-lista.component.html',
  styleUrls: ['./cursos-lista.component.scss'],
})
export class CursosListaComponent implements OnInit {
  // componenteRef é usado para definir o id da barra de pesquisa, retornando uma
  // referencia de qual componente está chamando o componente "barra-busca"
  componenteRef = 'cursos';
  stringPesquisa: string;
  paginaAtual: number;
  totalPaginas: number;
  totalResultados: number;
  eixos: any;
  ordecao: any;
  filtro: any;
  eixo: any;
  queryParamsSubscription: Subscription;
  realizouBusca = false;
  error = false;
  cursos: any;
  mensagem: any;

  constructor(
    private route: ActivatedRoute,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.route.data.subscribe((data) => {
      const {
        cursos: { itens, paginaAtual, totalPaginas, totalItens },
        eixos,
        cursoError,
        eixosError,
      } = data;

      this.error =
        cursoError !== undefined || eixosError !== undefined ? true : false;

      if (this.error) {
        this.mensagem = this.error;
      }

      if (!this.error) {
        this.cursos = itens;
        this.paginaAtual = paginaAtual;
        this.totalPaginas = totalPaginas;
        this.totalResultados = totalItens;
        this.eixos = eixos;

        if (!this.totalResultados || (!this.totalResultados && this.realizouBusca)) {
          this.mensagem = 'Desculpe, não encontramos nenhum resultado compatível com sua busca.';
        }

        if (this.totalResultados) {
          this.mensagem = 'Total de resultados encontrados ' + this.totalResultados;
        }
      }
    });
  }

  onPaginaSelecionada(numeroPagina: number) {
    this.paginaAtual = numeroPagina;
    this.router.navigate(['/cursos'], {
      queryParamsHandling: 'merge',
      queryParams: {
        pagina: numeroPagina,
      },
    });
  }

  recebeuInput(input: any) {
    this.realizouBusca = true;
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate(['/cursos'], {
        queryParamsHandling: 'merge',
        queryParams: {
          pagina: 1,
          eixoId: input.eixo,
          areaId: input.areaTecnologica,
          filtro: input.filtro,
          ordenacao: input.ordenacao,
          query: input.stringBusca,
        },
      });
    });
  }
}
